// Thread Model
cv.Thread =  Backbone.RESTModel.extend({
  defaults : {
  },

  saveMap : {
    'title' : 'title',
    'body' : 'body',
    'contact_id' : 'contact_id'
  },

  urlRoot: function(){
    return cv.api_path + '/threads';
  },

  initialize: function(){
    console.log('Thread model initialized.');
  }
});
Cocktail.mixin(cv.Thread, cv.mixins.SyncModel);

// Threads Collection
cv.Threads = Backbone.Collection.extend({
  initialize: function(options){
    console.log('Threads collection initialized.');
  },

  url: function() {
    return cv.api_path + "/threads?" + $.param(this.params);
  },

  model: cv.Thread
});
Cocktail.mixin(cv.Threads, cv.mixins.PaginateModel);
